import { API } from '../index';

export default {
  login: credentials => API.auth.post({ path: '/v4/users/login', data: credentials }),
};
